import { Box, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { BreadCrumb, DetailKeyValue } from "../../../../../../components"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { useGeneralConfigContext } from "../../context"
import { useLayoutEffect, useMemo, useState } from "react"
import { useInputForm } from "../../utils"
import { generalDisabled } from "../../../../../../utils/validate/validate"
import { useMutation } from "@tanstack/react-query"
import { emitEvent } from "../../../../../../hooks/emitter"
import { Events } from "../../../../../../hooks/emitter/types"
import { Types } from "../../../../../../utils/enums"
import { LoadingButton } from "@mui/lab"
import { configServices } from "../../../../../../utils/constants/callService"
import { ConfigBodyEdit } from "../../../../../../service/serviceAreaDepartment/body"
import { Item } from "../../../../../../utils/types/generals"
import Loader from "../../../../../../components/loader"

export function Edit() {
    const inputForm = useInputForm({ isEdit: true })
    const { inputForm: { input, setInput }, formData, setOldData, service, setItem, setLoadings, loadings } = useGeneralConfigContext()
    const { id } = useParams()
    const { t } = useTranslation()
    const styles = useStyles()
    const diabledBtn = useMemo(() => {
        const isGeneralDisabled = generalDisabled(input, formData.filterData)
        const existSomeRequest = !!formData.filterData?.preventiveCatalog?.value && !!formData.filterData?.correctiveCatalog?.value
        return isGeneralDisabled || !existSomeRequest
    }, [input, formData.filterData])
    const emits = useMemo(() => ({
        success: ({ message }: { message: string }) => { emitEvent(Events.snackbar, { open: true, type: Types.SUCCESS, message }) },
        error: ({ message }: { message: string }) => { emitEvent(Events.snackbar, { open: true, type: Types.ERROR, message }) },
    }), [])
    const config = useMutation({
        mutationFn: configServices.updateConfig,
        onSuccess: (data) => {
            if (!data.errors) {
                setOldData({
                    area: formData.filterData.areas,
                    department: formData.filterData.departments
                })
                emits.success({ message: t(`general.service.areaDepartment.form.snackbar.config.edit.success`) })
                return
            }
            emits.error({ message: t(`general.service.areaDepartment.form.snackbar.config.edit.error`) })
        },
        onError: () => {
            emits.error({ message: t(`general.service.areaDepartment.form.snackbar.config.edit.error`) })
        }
    })
    const submit = () => {
        if (!id) { return }
        const { departments, preventiveCatalog, correctiveCatalog } = formData.filterData
        const body: ConfigBodyEdit = {
            departmentId: departments.value,
            ...!!correctiveCatalog?.value && { correctiveCatalogId: correctiveCatalog.value },
            ...!!preventiveCatalog?.value && { preventiveCatalogId: preventiveCatalog.value }
        }
        config.mutate({ body, id })
    }

    const getConfig = async () => {
        if (!id) { return }
        setLoadings(prev => ({ ...prev, editForm: true }))
        const response = await configServices.getConfigById({ id })
        setLoadings(prev => ({ ...prev, editForm: false }))
        const { area, department, preventive, corrective } = response
        const departmentItem: Item = { label: department.name, value: department.id, id: department.id.toString() }
        const areaItem: Item = { label: area.name, value: area.id, id: area.id.toString() }
        const preventiveItem: Item = { label: preventive.name, value: preventive.id, id: preventive.id.toString() }
        const correctiveItem: Item = { label: corrective.name, value: corrective.id, id: corrective.id.toString() }
        setOldData({ area: areaItem, department: departmentItem })
        service.getDepartmentsWithoutConfig({ areasIds: [areaItem.value], departmentItem })

        formData.handleDefaultValues({
            defaultValue: {
                areas: areaItem,
                departments: departmentItem,
                preventiveCatalog: preventiveItem,
                correctiveCatalog: correctiveItem,
            }
        })
    }
    useLayoutEffect(() => {
        setItem({})
        setInput(inputForm)
        service.getAreasFilterService()
        service.getCatalogList()
        getConfig()
    }, [])

    return (
        <Box className="main-container">
            <Box sx={styles.center}>
                <Box sx={styles.form}>
                    <BreadCrumb
                        removeBreadcrumb={['organization-chart']}
                        replaceLabels={{
                            form: 'area-department-create',
                            formEdit: 'area-department-edit',
                            'organization-area-department': 'area-department-config'
                        }}
                    />

                    <Typography variant="subtitle_grey" color='secondary.main' fontWeight='bold'>{t(`general.service.areaDepartment.form.titleEdit`)}</Typography>

                    <CustomPaper sx={styles.container}>
                        {loadings.editForm && <Loader />}

                        {
                            !loadings.editForm && (
                                <>
                                    <DinamicForm input={Object.values(input)} onChange={formData.onChange} values={formData.filterData} spacing={{ row: 3, column: 3 }} />

                                    <Box sx={styles.footer}>
                                        <LoadingButton loading={config.isPending} onClick={submit} disabled={diabledBtn} variant="contained">{t('general.continue')}</LoadingButton>
                                    </Box>
                                </>
                            )
                        }
                    </CustomPaper>
                </Box>
            </Box>
        </Box>
    )
}